import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { useLang } from '../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../hooks/use-modal-params';
import { useDishMenuStore } from '../../../../../../store/use-dish-menu-store';
import { useDishStore } from '../../../../../../store/use-dish-store';
import { useMenuInformerTableFilters } from './use-menu-informer-table-filters';

export const useMenuInformerTable = () => {
  const { t, getLocale } = useLang();
  const { getQueryParams, addQueryParams } = useQueryParams();
  const params = getQueryParams();
  const branchId = params.branchId;
  const menuId = params.menuId;

  const { isLoading: isLoadingFetch, putDishStatus, deleteDish } = useDishStore();
  const { menuList } = useDishMenuStore();

  const filteredMenuList = branchId
    ? menuList?.filter((item) => Number(branchId) === item.place_id)
    : menuList;

  const selectedMenu = filteredMenuList?.find((menu) => menu.id === menuId);

  const createDishModal = useModalParams('createDish');
  const copyDishModal = useModalParams('copyDish');

  const filteredDishes = useMenuInformerTableFilters(selectedMenu?.dishes);

  return {
    createDishModal,
    copyDishModal,

    t,
    getLocale,
    isLoadingFetch,

    putDishStatus,

    selectedMenu,
    dishes: filteredDishes,
    addQueryParams,
    deleteDish,
  };
};
